import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);

// Enregistrement du service worker (PWA installable + offline + push) — version en ligne seulement.
// En développement, il mettait en cache les modules de Vite (« cache d'abord ») : ancien code servi, voire
// deux copies de React mélangées (page blanche). Un service worker resté d'avant y est retiré.
if ('serviceWorker' in navigator && !import.meta.env.PROD) {
  void navigator.serviceWorker
    .getRegistrations()
    .then((regs) => Promise.all(regs.map((r) => r.unregister())))
    .then(() => caches.keys())
    .then((keys) => Promise.all(keys.filter((k) => k.startsWith('permio-candidat')).map((k) => caches.delete(k))))
    .catch(() => undefined);
}
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // best-effort : l'app fonctionne sans SW.
    });
  });
}
